// Константа для действия "Запросить ингредиенты"
export const FETCH_INGREDIENTS: 'FETCH_INGREDIENTS' = 'FETCH_INGREDIENTS';
// Константа для действия "Успешно получены ингредиенты"
export const FETCH_INGREDIENTS_SUCCESS: 'FETCH_INGREDIENTS_SUCCESS' = 'FETCH_INGREDIENTS_SUCCESS';
// Константа для действия "Не удалось получить ингредиенты"
export const FETCH_INGREDIENTS_FAILED: 'FETCH_INGREDIENTS_FAILED' = 'FETCH_INGREDIENTS_FAILED';
